import React from "react";

function IllustrationRdcListingToolkit() {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 96">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.25 17A5.75 5.75 0 0 1 52 11.25h24A5.75 5.75 0 0 1 81.75 17v1.25H102a7.75 7.75 0 0 1 7.75 7.75v52a7.75 7.75 0 0 1-7.75 7.75H26A7.75 7.75 0 0 1 18.25 78V26A7.75 7.75 0 0 1 26 18.25h20.25V17Zm3.5 1.25h28.5V17A2.25 2.25 0 0 0 76 14.75H52A2.25 2.25 0 0 0 49.75 17v1.25ZM26 21.75A4.25 4.25 0 0 0 21.75 26v5.949h84.5V26a4.25 4.25 0 0 0-4.25-4.25H26Zm80.25 13.699h-84.5V78A4.25 4.25 0 0 0 26 82.25h76a4.25 4.25 0 0 0 4.25-4.25V35.449Z"
        className="fill-secondary"
      />
      <path
        d="M84 32a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0v-4Z"
        className="fill-secondary"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M82.25 32a2.75 2.75 0 1 1 5.5 0v4a2.75 2.75 0 1 1-5.5 0v-4Z"
        className="fill-secondary"
      />
      <path
        d="M43 32a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0v-4Z"
        className="fill-secondary"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.25 32a2.75 2.75 0 1 1 5.5 0v4a2.75 2.75 0 1 1-5.5 0v-4Z"
        className="fill-secondary"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77 59.1 65.012 47 53 59.1h3.664v10.857h16.68V59.1H77Zm-7.414-3.17c-.317-.312-.823-.483-1.433-.483-1.005 0-1.638.412-2.073.77l-.008.008c-.435.411-.934.971-1.345 2.059l.019-.863.005-.248c.016-.607.023-1.127.023-1.19 0-.131-.094-.271-.3-.271h-3.901v.326l.103.008c.316.023.617.054.894.248a.976.976 0 0 1 .443.677c.079.334.079 1.313.079 1.733v5.556c0 .567-.016 1.345-.103 1.865-.158.505-.324.66-.665.832-.19.085-.427.147-.696.178l-.11.008v.327h5.823v-.327l-.103-.008a1.977 1.977 0 0 1-.648-.155c-.175-.062-.325-.218-.483-.505-.23-.482-.372-1.026-.372-2.347v-2.316c0-.7.032-1.375.055-1.67.261-1.85 1.282-3.335 1.947-3.335.253 0 .42.272.601.708.214.497.515 1.025 1.377 1.025.855 0 1.306-.707 1.306-1.414.008-.482-.135-.87-.435-1.197Z"
        fill="#D92228"
      />
    </svg>
  );
}

export default IllustrationRdcListingToolkit;
